<template>
    <div>
        <div class="d-flex justify-content-center mb-3" v-if="!fluxo || aba != 'marcacao'">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'marcacao' ? 'active' : ''" @click.prevent="abrir('marcacao')">
                        <i class="fa fa-calendar-plus-o fa-fw mr-2" aria-hidden="true"></i>
                        Marcação
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'confirmacao' ? 'active' : ''" @click.prevent="abrir('confirmacao')">
                        <i class="fas fa-user-check fa-fw mr-2"></i>
                        Confirmação
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'bloqueio' ? 'active' : ''" @click.prevent="abrir('bloqueio')" >
                        <i class="fa fa-ban fa-fw mr-2" aria-hidden="true"></i>
                        Bloqueios
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'lista' ? 'active' : ''" @click.prevent="abrir('lista')" >
                        <i class="fa fa-list-ol mr-2" aria-hidden="true"></i>
                        Lista de Espera
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'mapasala' ? 'active' : ''" @click.prevent="abrir('mapasala')" >
                        <i class="fas fa-map fa-fw mr-2"></i>
                        Mapa de Sala
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'atendimento' ? 'active' : ''" @click.prevent="abrir('atendimento')" >
                        <i class="fa-solid fa-play fa-fw mr-2"></i>
                        Atendimento
                    </a>
                </li>
            </ul>
        </div>

        <marcacao 
            v-if="aba == 'marcacao'" 
            :cc="true"
            :autorizacao="autorizacao"
            :remarcacao="remarcacao"
            :adicao="adicao"
            :params="$route.params"
            @fluxo="estado" />

        <confirmacao v-if="aba == 'confirmacao'" />
            
        <bloqueio :cc="true" v-if="aba == 'bloqueio'" />

        <lista-espera :cc="true" v-if="aba == 'lista'" />

        <mapa-de-sala 
            v-if="aba == 'mapasala'" />

        <atendimento-enfermagem :cc="true" v-if="aba == 'atendimento'" />
        
    </div>
</template>

<script>
import Marcacao from '../callcenter/Marcacao.vue';
import Confirmacao from '../callcenter/Confirmacao.vue';
import Bloqueio from '../callcenter/Bloqueio.vue';
import MapaDeSala from '../callcenter/MapaDeSala.vue';
import AtendimentoEnfermagem from '../enfermagem/AtendimentoEnfermagem.vue';
import ListaEspera from '../callcenter/ListaEspera.vue';

export default {
    data() { 
        return { 
            fluxo: null, 
        };
    },

    components: { 
        Marcacao, 
        Bloqueio,
        MapaDeSala,  
        Confirmacao,
        AtendimentoEnfermagem, 
        ListaEspera, 
    }, 

    props: ['aba', 'autorizacao', 'remarcacao', 'adicao'], 

    methods: { 
        estado(fluxo) { 
            this.fluxo = fluxo;
        },

        abrir(aba) { 
            if ( aba != this.aba ) { 
              this.$router.push({ path: '/centro-cirurgico/' + aba });
            }

            this.set_bread(aba);
        },

        set_bread (aba) { 
            if ( aba == 'marcacao' ) { 

                this.$store.commit(
                    'setBreadcrumb', 
                    [
                        { name: "Centro Cirúrgico", path: "/centro-cirurgico/marcacao" },
                        { name: "Marcação", path: "/centro-cirurgico/marcacao"}
                    ]
                );

            }
        }
    },

    mounted() { 
        this.set_bread(this.aba);
    }
}
</script>